import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCurrentUser = async () => {
    setIsLoading(true);
    try {
      const response = await api.get('/auth/me');
      setCurrentUser(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching current user:', error);
      setCurrentUser(null);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const clearUser = () => {
    setCurrentUser(null);
  };

  // Don't automatically fetch user on mount to avoid conflicts with existing auth flow

  return (
    <UserContext.Provider value={{ 
      currentUser,
      setCurrentUser,
      isLoading,
      fetchCurrentUser,
      clearUser
    }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
